export default __webpack_public_path__ + "static/media/maisons_laffittemini.c4e39772.jpg";